import { ACTIONS_INTEGRATION } from '../../constants.js';

const initialMessagesIntegration = { 
    actionType: ACTIONS_INTEGRATION.NONE
  };

const messagesIntegrations = (state = initialMessagesIntegration, action) => {
  state = initialMessagesIntegration;
  switch (action.type) {
    case ACTIONS_INTEGRATION.MESSAGE:
      return { actionType: ACTIONS_INTEGRATION.MESSAGE, 
               dataMessageIntegration : action.dataIntegration};
    default:
      return state;
  }
}

export default messagesIntegrations;



// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_actions_integration.js